export default __webpack_public_path__ + "static/media/JournalTypeConflict@32.a54b7028.svg";